import clsx from "clsx";
import React, { FC, ReactNode } from "react";

import s from "./s.module.less";

interface IProps {
  label?: string;
  children: ReactNode;
  className?: string;
  labelClassName?: string;
  required?: boolean;
}

const FieldWrapper: FC<IProps> = ({
  label,
  children,
  className = "",
  labelClassName = "",
  required = false,
}) => {
  return (
    <div className={clsx(s.fieldItem, { [className]: true })}>
      {label && (
        <label className={clsx(s.fieldLabel, { [labelClassName]: true })}>
          {label}
          {required && <span className={s.requiredMark}>*</span>}
        </label>
      )}
      {children}
    </div>
  );
};

export default FieldWrapper;
